<template>
  <div style="background: linear-gradient(to bottom, #f0f8ff, #e6f7ff);;">
    <Header :jifen="jifen" />
<!--    <mall-header @search="search" :jifen="jifen" />-->

    <!-- 商品详情容器 -->
    <div class="product-detail-container">
      <!-- 上半部分 - 商品基本信息 -->
      <div class="product-basic-info">
        <!-- 商品图片区域 -->
        <div class="product-gallery">
          <div class="zoom-view" :class="{'zoom-view-show': show }" :style="{width: `${zoomAreaSize}px`, height: `${zoomAreaSize}px`}">
            <img :src="getFileUrl(goodsDetail.bridgePicUrl) || '/noimage.png'" alt="" srcset="" :style="zoomImageStyle">
          </div>
          <div class="main-image">

            <div class="preview-wrap">
              <div class="preview">
                <div
                    class="preview-image"
                    @mouseenter="onMouseEnter"
                    @mousemove="onMouseMove"
                    @mouseleave="onMouseLeave"
                    ref="image"
                >
                  <img :src="getFileUrl(goodsDetail.bridgePicUrl) || '/noimage.png'" class="img"/>
                  <div class="zoomer" :class="{'zoomer-show': show }" :style="zoomerStyle"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 商品信息区域 -->
        <div class="product-info">
          <h1 class="product-title">{{ goodsDetail.name }}</h1>
<!--          <div class="product-subtitle">{{ goodsDetail.specs }}{{ goodsDetail.specsUnit }}</div>-->

          <div class="price-section">
            <div class="price-label">兑换积分</div>
            <div class="points-value"><i><img src="@/assets/icon/jifen2.png" style="width: 17px;margin-bottom: 4px;" /></i> {{ goodsDetail.points }}</div>
            <div class="user-points-balance">我的积分: <span>{{ jifen || 0 }}</span></div>
          </div>

          <div class="attributes-list">
            <div class="attribute-item">
              <div class="attribute-label">品牌</div>
              <div class="attribute-value">{{ goodsDetail.brandName }}</div>
            </div>
            <div class="attribute-item">
              <div class="attribute-label">规格</div>
              <div class="attribute-value">{{ goodsDetail.specs }}{{ goodsDetail.specsUnit }}</div>
            </div>
            <div class="attribute-item">
              <div class="attribute-label">库存</div>
              <div class="attribute-value">{{ goodsDetail.remainNum }}</div>
            </div>
          </div>

          <div class="company-info">
            <div class="company-name">
              <i><img src="@/assets/icon/gongsi.png" style="width: 17px;margin-bottom: 4px;" /></i>
              <span>{{ $route.query.name || '' }}</span>
            </div>
            <div class="company-contact">
              <div class="contact-item">
                <i><img src="@/assets/icon/phone.png" style="width: 17px;margin-bottom: 4px;" /></i>
                <span>{{ goodsDetail.directorPhone || '' }}</span>
              </div>
            </div>
          </div>

          <!-- 购买区域 -->
          <div class="action-section">
            <div class="quantity-selector">
              <div class="quantity-label">数量</div>
              <div class="quantity-control">
                <button class="quantity-btn" @click="addBuyNum('del')">-</button>
                <input type="text" class="quantity-input" v-model="buyNum">
                <button class="quantity-btn" @click="addBuyNum('add')">+</button>
              </div>
              <div class="stock-info">库存{{ goodsDetail.remainNum }}</div>
            </div>
            <div class="action-buttons">
              <button class="btn-exchange"  @click="addCart(true)">立即兑换</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 下半部分 - 商品详情 -->
      <div class="product-detail-section">
        <div class="detail-tabs">
          <div class="tab-item active">详细介绍</div>
        </div>

        <div class="tab-content">
          {{ goodsDetail.description }}
        </div>
      </div>
    </div>

    <div style="height: 10px"></div>
<!--    <div id="goods-detail">-->
<!--      <div class="zoom-view" :class="{'zoom-view-show': show }" :style="{width: `${zoomAreaSize}px`, height: `${zoomAreaSize}px`}">-->
<!--        <img :src="getFileUrl(goodsDetail.bridgePicUrl) || '/noimage.png'" alt="" srcset="" :style="zoomImageStyle">-->
<!--      </div>-->
<!--      <div class="product-info-wrap">-->
<!--        <div class="preview-wrap">-->
<!--          <div class="preview">-->
<!--            <div-->
<!--                class="preview-image"-->
<!--                @mouseenter="onMouseEnter"-->
<!--                @mousemove="onMouseMove"-->
<!--                @mouseleave="onMouseLeave"-->
<!--                ref="image"-->
<!--            >-->
<!--              <img :src="getFileUrl(goodsDetail.bridgePicUrl) || '/noimage.png'" class="img"/>-->
<!--              <div class="zoomer" :class="{'zoomer-show': show }" :style="zoomerStyle"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="item-info-wrap">-->
<!--          <p class="sku-name" :title="goodsDetail.name">{{ goodsDetail.name }}</p>-->
<!--          <div class="sku-desc">-->
<!--            <p>-->
<!--              <span class="rowTitle">积分：</span>-->
<!--              <span class="price">{{ goodsDetail.points }}</span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <span class="rowTitle">品牌：</span>-->
<!--              <span>{{ goodsDetail.brandName }}</span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <span class="rowTitle">规格：</span>-->
<!--              <span>{{ goodsDetail.specs }}</span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <span class="rowTitle">库存：</span>-->
<!--              <span>{{ goodsDetail.remainNum }}</span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <span class="rowTitle">供应商：</span>-->
<!--              <span>{{ goodsDetail.companyName }}</span>-->
<!--            </p>-->
<!--            <p>-->
<!--              <span class="rowTitle">联系电话：</span>-->
<!--              <span>{{ goodsDetail.directorPhone || '' }}</span>-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="alignCt">-->
<!--            <span class="rowTitle">数量：</span>-->
<!--            <span class="operBtn" :class="{stopOper: buyNum === 1}" @click="conuntChange(buyNum - 1)"><a-icon type="minus" /></span>-->
<!--            <div class="buyNum">-->
<!--              <input type="number" class="ant-input-number" v-model="buyNum" @blur="conuntChange($event.target.value)"/>-->
<!--            </div>-->
<!--            <span class="operBtn" @click="conuntChange(buyNum + 1)"><a-icon type="plus"/></span>-->
<!--          </div>-->
<!--          <div class="but">-->
<!--&lt;!&ndash;            :disabled="goodsDetail.points > jifen"&ndash;&gt;-->
<!--            <a-button type="primary" :disabled="(goodsDetail.points > jifen) || !(Number(goodsDetail.remainNum) +1 > buyNum)" style="margin-right: 20px;" @click="addCart(true)" :loading="loading">立即兑换</a-button>-->
<!--&lt;!&ndash;            <a-button icon="shopping-cart" style="border-color: #165dff;color: #165dff" type="primary" ghost @click="addCart(false)" :loading="cartLoading">加入购物车</a-button>&ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div>-->
<!--        <a-tabs>-->
<!--          <a-tab-pane key="1" tab="详细介绍">-->
<!--            {{ goodsDetail.description }}-->
<!--          </a-tab-pane>-->
<!--        </a-tabs>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>
<script>
import Header from '@/components/Header'
import {insertCart, loadGoodsAvailablePoints, loadGoodsDetail} from "@/api/mall";
import fileUrlMixin from "@/mixins/fileUrlMixin";
import MallHeader from './Header'
import {advertisingReport} from "@/api/account";
export default {
  mixins: [fileUrlMixin],
  components: {
    Header,
    MallHeader
  },
  data () {
    return {
      goodsDetail: {},
      show: false,
      zoomer: {
        left: 0,
        top: 0
      },
      zoomerSize: 235,
      zoomAreaSize: 540,
      zoomImage: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      buyNum: 1,
      loading: false,
      cartLoading: false,
      jifen: 0
    }
  },
  computed: {
    zoomerStyle () {
      return {
        left: `${this.zoomer.left}px`,
        top: `${this.zoomer.top}px`,
        width: `${this.zoomerSize}px`,
        height: `${this.zoomerSize}px`
      }
    },
    zoomImageStyle () {
      return {
        width: `${this.zoomImage.width}px`,
        height: `${this.zoomImage.height}px`,
        left: `${-this.zoomImage.left}px`,
        top: `${-this.zoomImage.top}px`
      }
    }
  },
  mounted () {
    this.getDetail(this.$route.query?.id)
    // if (this.$route.query?.clickId) {
    //   this.uploadMethod()
    // }
  },
  methods: {
    uploadMethod () {
      // 广告上报
      advertisingReport([{
        deviceId: '',
        sessionId: '',
        clickId: this.$route.query.clickId,
        eventType: 'page_view', // 什么事件
        adId: this.$route.query.adId,
        eventTime: Date.now(),
        url: '/goodsDetail', // 跳转后的页面地址
        position: '积分商品详情',
        adType: this.$route.query.adType
      }])
    },
    addBuyNum (t) {
      if(t === 'add')
        this.buyNum++
      if(t === 'del' && this.buyNum !== 1)
        this.buyNum--
    },
    getloadGoodsAvailablePoints (d) {
      loadGoodsAvailablePoints(d).then(res => {
        this.jifen = res.data.points || 0
      })
    },
    getDetail (id) {
      loadGoodsDetail(id).then(res => {
        this.goodsDetail = res.data
        this.getloadGoodsAvailablePoints({ supplierCompanyId: this.goodsDetail.companyId, pointsType: this.goodsDetail.type })
      })
    },
    onMouseEnter () {
      const rect = this.$refs.image.getBoundingClientRect()
      const r = this.zoomAreaSize / this.zoomerSize
      this.zoomImage.width = rect.width * r
      this.zoomImage.height = rect.height * r
      this.show = true
    },
    onMouseMove (e) {
      const rect = this.$refs.image.getBoundingClientRect()
      const r = this.zoomAreaSize / this.zoomerSize
      this.zoomer.left = e.clientX - rect.left - this.zoomerSize / 2
      if (this.zoomer.left < 0) this.zoomer.left = 0
      if (this.zoomer.left > rect.width - this.zoomerSize) {
        this.zoomer.left = rect.width - this.zoomerSize
      }
      this.zoomer.top = e.clientY - rect.top - this.zoomerSize / 2
      if (this.zoomer.top < 0) this.zoomer.top = 0
      if (this.zoomer.top > rect.height - this.zoomerSize) {
        this.zoomer.top = rect.height - this.zoomerSize
      }
      this.zoomImage.left = this.zoomer.left * r
      this.zoomImage.top = this.zoomer.top * r
    },
    onMouseLeave () {
      this.show = false
    },
    addCart (type) {
      if ((Number(this.goodsDetail.points * this.buyNum) > this.jifen) || !(Number(this.goodsDetail.remainNum) +1 > this.buyNum)) {
        this.$message.error('积分不足或库存不足', 1)
        return
      }
      type ? this.loading = true : this.cartLoading = true
      try {
        this.$router.push({
          path: 'checkout-order'
        })
        localStorage.setItem('settleAccounts', JSON.stringify({
          companyId: this.goodsDetail.companyId,
          companyName: this.goodsDetail.companyName,
          id: this.goodsDetail.id,
          shoppingCarts: [{...this.goodsDetail, count: this.buyNum}]
        }))
        // insertCart({ goodsId: this.goodsDetail.id, count: this.buyNum }).then(res => {
        //   if (!res.code) {
        //     if (!type) {
        //       this.$HttpHandlerService.checkCode(res, true, '加入成功')
        //     } else {
        //       this.$router.push({
        //         path: 'cart'
        //       })
        //     }
        //   }
        // })
      } finally {
        this.loading = false
        this.cartLoading = false
      }
    },
    conuntChange (count) {
      if (count < 1) {
        this.buyNum = 1
        return
      }
      this.buyNum = parseInt(count)
    },
    search (key) {
      this.$router.push({
        path: '/',
        query: {
          name: key
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>

/* 商品详情容器 */
.product-detail-container {
  max-width: 1200px;
  margin: 30px auto;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

/* 上半部分 - 商品基本信息 */
.product-basic-info {
  display: flex;
  padding: 30px;
  border-bottom: 1px solid #f0f4f8;
}

/* 商品图片区域 */
.product-gallery {
  width: 450px;
  margin-right: 30px;
  position: relative;
}

.main-image {
  width: 100%;
  height: 450px;
  //background: linear-gradient(135deg, #f5f7fa, #e4edf9);
  border-radius: 12px;
  //display: flex;
  //align-items: center;
  //justify-content: center;
  //overflow: hidden;
}

.main-image i {
  font-size: 80px;
  color: #a1c4fd;
}

.thumbnail-list {
  display: flex;
  margin-top: 15px;
  gap: 10px;
}

.thumbnail {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f5f7fa, #e4edf9);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.3s ease;
}

.thumbnail i {
  font-size: 24px;
  color: #a1c4fd;
}

.thumbnail:hover, .thumbnail.active {
  border-color: #84fab0;
}

/* 商品信息区域 */
.product-info {
  flex: 1;
  padding: 10px 0;
}

.product-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #2c3e50;
  line-height: 1.4;
}

.product-subtitle {
  font-size: 16px;
  color: #7f8c8d;
  margin-bottom: 20px;
}

.price-section {
  background: #f8fafc;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.price-label {
  font-size: 14px;
  color: #7f8c8d;
  margin-bottom: 5px;
}

.points-value {
  font-size: 28px;
  font-weight: 700;
  color: #e74c3c;
}

.points-value i {
  margin-right: 5px;
  color: #ffd700;
}

.user-points-balance {
  font-size: 14px;
  color: #7f8c8d;
  margin-top: 5px;
}

.user-points-balance span {
  color: #2c3e50;
  font-weight: 600;
}

/* 商品属性列表 */
.attributes-list {
  margin: 20px 0;
}

.attribute-item {
  display: flex;
  margin-bottom: 15px;
  font-size: 14px;
}

.attribute-label {
  width: 80px;
  color: #7f8c8d;
}

.attribute-value {
  flex: 1;
  color: #2c3e50;
  font-weight: 500;
}

.company-info {
  background: #f8fafc;
  padding: 15px;
  border-radius: 8px;
  margin-top: 25px;
}

.company-name {
  font-weight: 600;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.company-name i {
  color: #84fab0;
}

.company-contact {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-top: 10px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #2c3e50;
}

.contact-item i {
  color: #a1c4fd;
}

/* 购买区域 */
.action-section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px dashed #e0e6ed;
}

.quantity-selector {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}

.quantity-label {
  width: 80px;
  font-size: 14px;
  color: #7f8c8d;
}

.quantity-control {
  display: flex;
  align-items: center;
}

.quantity-btn {
  width: 30px;
  height: 30px;
  background: #f0f4f8;
  border: none;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2c3e50;
}

.quantity-input {
  width: 50px;
  height: 30px;
  text-align: center;
  border: 1px solid #e0e6ed;
  margin: 0 5px;
}

.stock-info {
  font-size: 14px;
  color: #7f8c8d;
  margin-left: 15px;
}

.action-buttons {
  display: flex;
  gap: 15px;
}

.btn-exchange {
  background: linear-gradient(135deg, #ff9a9e, #fad0c4);
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 30px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  font-size: 16px;
}

.btn-exchange:hover {
  opacity: 0.9;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
}

.btn-favorite {
  background: white;
  border: 1px solid #e0e6ed;
  color: #2c3e50;
  padding: 12px 20px;
  border-radius: 30px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-favorite:hover {
  background: #f8fafc;
  border-color: #a1c4fd;
}

/* 下半部分 - 商品详情 */
.product-detail-section {
  padding: 30px;
}

.detail-tabs {
  display: flex;
  border-bottom: 1px solid #e0e6ed;
  margin-bottom: 20px;
}

.tab-item {
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 600;
  color: #7f8c8d;
  position: relative;
}

.tab-item.active {
  color: #2c3e50;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #ff9a9e, #fad0c4);
}

.tab-content {
  min-height: 300px;
}

.detail-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #2c3e50;
}

.detail-description {
  color: #7f8c8d;
  line-height: 1.8;
  margin-bottom: 20px;
}

.detail-image {
  width: 100%;
  background: #f8fafc;
  height: 400px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.detail-image i {
  font-size: 60px;
  color: #a1c4fd;
}

.specs-table {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.specs-table tr:nth-child(even) {
  background: #f8fafc;
}

.specs-table th, .specs-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e6ed;
}

.specs-table th {
  width: 150px;
  color: #7f8c8d;
  font-weight: 500;
}

.specs-table td {
  color: #2c3e50;
  font-weight: 500;
}

/*
 -------------------------------------------
*/
#goods-detail{
  width: 1200px;
  margin: 20px auto;
  background-color: white;
  position: relative;
}
.zoom-view {
  position: absolute;
  left: 340px;
  top: 25px;
  border: 1px solid #e4e4e4;
  text-align: center;
  overflow: hidden;
  display: none;
  z-index: 10;

  img {
    position: absolute;
    left: 0;
    top: 0;
  }
  &.zoom-view-show {
    display: block;
  }
}
.product-info-wrap {
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.preview-wrap {
  //width: 300px;
  //height: 300px;
  float: left;
  border: 1px solid #eee;

  .preview {
    position: relative;
    padding: 0;
    height: 100%;

    .preview-image {
      height: 100%;
      width: 100%;
      line-height: 300px;
      overflow: hidden;
      .img {
        max-width: 100%;
        max-height: 100%;
      }
      .zoomer {
        position: absolute;
        border: 1px solid #aaa;
        background: 50% top no-repeat #fede4f;
        opacity: 0.5;
        cursor: move;
        width: 235px;
        height: 235px;
        left: 0;
        top: 0;
        visibility: hidden;
      }

      .zoomer-show {
        visibility: visible;
      }
    }

  }
}
.item-info-wrap {
  font-family: PingFang SC;
  color: #333333;
  width: 800px;
  float: left;
  margin-left: 20px;
  font-size: 14px;
  .sku-name{
    font-size: 20px;
    font-weight: 550;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
  .sku-desc{
    background-color: #f6f6f6;
    padding: 12px 10px 14px 0;
    margin: 15px 0;
    border-radius: 4px;
    .price{
      font-size: 24px;
      font-weight: 550;
      color: #de0000;
    }
  }
  .rowTitle{
    padding: 0 10px;
    white-space: nowrap;
    color: #999;
  }
  .alignCt{
    .buyNum{
      display: inline-block;
      width: 60px;
      margin: 0 2px;
      font-size: 14px;
      .ant-input-number{
        margin: 10px 0;
        width: 60px;
        box-sizing: border-box;
        text-align: center;
        color: #232326;
        border: 1px solid #cbcbcb;
        padding: 0;
        background-color: #fff;
        outline: none;
      }
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
      }
      input[type='number'] {
        -moz-appearance: textfield !important;
      }
    }
    .operBtn{
      display: inline-block;
      width: 28px;
      height: 28px;
      text-align: center;
      line-height: 28px;
      background: #f6f6f6;
      border-radius: 0 3px 3px 0;
      cursor: pointer;
    }
    .stopOper{
      background: #fff;
      cursor: not-allowed;
    }
  }
  .but {
    margin-top: 20px;
  }
}
/deep/ .ant-tabs-tab-active {
  color: #165dff;
}
/deep/ .ant-tabs-tab-active:hover {
  color: #165dff;
}
/deep/ .ant-tabs-ink-bar{
  background-color: #165dff;
}
</style>
